import React, {useState} from 'react'
import {Box, Flex, useStyleConfig, HStack} from '@chakra-ui/react'
import {VerticalLineIcon} from '../icons'
import {defineMessages, FormattedMessage} from 'react-intl'
import CustomLink from '../custom-link'
import {useLocation} from 'react-router-dom'
import PropTypes from 'prop-types'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {BRAND_KEY} from '../../brand'
import {remCalc} from '../../theme/_utils'

const CorporateBenefitBanner = ({onExit}) => {
    const styles = useStyleConfig('SovraHeader')
    const {locale} = useMultiSite()
    const location = useLocation()

    const landingUrl = useState(`/${locale?.alias}` + location.search)

    const isKenwood = BRAND_KEY === 'kenwood'
    const isBraun = BRAND_KEY === 'braun'
    const labels = defineMessages({
        kenwood: {
            id: 'corporate_benefit_banner.title.kenwood',
            defaultMessage: 'Discover the Corporate Benefit offer',
        },
        braun: {
            id: 'corporate_benefit_banner.title.braun',
            defaultMessage: 'Discover the Corporate Benefit offer',
        },
        otherBrands: {
            id: 'corporate_benefit_banner.title',
            defaultMessage: 'Discover the Corporate Benefit offer',
        },
        kenwoodExit: {
            id: 'corporate_benefit_banner.exit.kenwood',
            defaultMessage: 'Exit',
        },
        braunExit: {
            id: 'corporate_benefit_banner.exit.braun',
            defaultMessage: 'Exit',
        },
        otherBrandsExit: {
            id: 'corporate_benefit_banner.exit',
            defaultMessage: 'Exit',
        },
    })
    const linkVariant = isBraun ? 'icon-button' : 'inverse-icon-button'

    return (
        <Flex w="100%" pos="relative" zIndex={1200}>
            <Box {...styles.container} {...styles.containerDesktop} display="flex">
                <HStack {...styles.hstack}>
                    <CustomLink
                        isExternal={false}
                        href={landingUrl}
                        asButton={true}
                        variant={linkVariant}
                        {...styles.label}
                        {...styles.labelColor}
                    >
                        <FormattedMessage
                            {...(isKenwood
                                ? labels.kenwood
                                : isBraun
                                ? labels.braun
                                : labels.otherBrands)}
                        />
                    </CustomLink>
                    <Flex align="center" justify="center" flex="1">
                        {isBraun ? (
                            <Box w={remCalc(6)} h={remCalc(1)} bg="background.dark" opacity="0.5" />
                        ) : (
                            <VerticalLineIcon {...styles.icon} />
                        )}
                    </Flex>
                    <CustomLink
                        isExternal={false}
                        onClick={async (e) => {
                            e.preventDefault()
                            if (onExit) {
                                await onExit()
                            }
                        }}
                        asButton={true}
                        variant={linkVariant}
                        {...styles.label}
                        {...styles.labelColor}
                    >
                        <FormattedMessage
                            {...(isKenwood
                                ? labels.kenwoodExit
                                : isBraun
                                ? labels.braunExit
                                : labels.otherBrandsExit)}
                        />
                    </CustomLink>
                </HStack>
            </Box>
        </Flex>
    )
}

CorporateBenefitBanner.propTypes = {
    onExit: PropTypes.func.isRequired,
}

CorporateBenefitBanner.getTemplateName = () => 'corporate-benefit-banner'

export default CorporateBenefitBanner
